import { useState, useEffect } from "react";
// components
import AnimationLoading from "../../components/Animationloading";
import { covertTimeZone, FormatNumber, NewCovertTimeZone, numberFormat } from "../../helper";

// apollo-client
import { useLazyQuery } from "@apollo/client";
import { GET_REPORT_CATEGORY_V2 } from "../../apollo/dashboard/query";

// react-bootrap
import { Row, Table, Col, Card, Button, Form } from "react-bootstrap";

// react-apexcharts
import ReactApexChart from "react-apexcharts";
import BreadCrumbComponent from "../../components/BreadCrumbComponent";
import CurrentDateComponents from "../../components/CurrentDateComponents";
import { startDateAndEndDate } from "../../components/handleDate";
import { GET_CATEGORYS } from "../../apollo/category/query";

export default function ReportCategory() {
  let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const [reportCategory, setReportCategory] = useState();
  const [reportCategoryTotal, setReportCategoryTotal] = useState(0);
  const [reportCategoryTotalAmount, setReportCategoryTotalAmount] = useState(0);
  const [reportCategoryTotalPrice, setReportCategoryTotalPrice] = useState(0);
  const [reportCategoryTotalOriginPrice, setReportCategoryTotalOriginPrice] = useState(0);
  const [reportCategoryTotalDiscount, setReportCategoryTotalDiscount] = useState(0);

  const [isCurrentModals, setIsCurrentModals] = useState(false);
  const [cdFillter, setCdFillter] = useState({
    createdAt_gte: startDateAndEndDate().startMonth,
    createdAt_lt: startDateAndEndDate().endMonth,
  });
  const [status, setStatus] = useState("ALL");
  const [activeButton, setActiveButton] = useState("thisMonth");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);

  const [getCategory] = useLazyQuery(GET_CATEGORYS, { fetchPolicy: "cache-first", 
    onCompleted: (data) => {
      // console.log("🟢 Get category data success");
        if (data?.categories?.data?.length > 0) {
          setCategories(data?.categories?.data);
        } else {
          setCategories([]);
          console.log("🔴 Get category data failed");
        }
    }  
  });

  // ============== > UseLazyQuery And UseMutaion <==============

  const [getreportCategory, { loading }] =
    useLazyQuery(GET_REPORT_CATEGORY_V2, { fetchPolicy: "cache-first",
      onCompleted: (data) => {
        // console.log("🟢 Get data success");
        if (data?.reportOrderCategoryV2?.status){
          setReportCategory(data?.reportOrderCategoryV2?.data);
          setReportCategoryTotal(data?.reportOrderCategoryV2?.data?.length || 0);
          setReportCategoryTotalAmount(data?.reportOrderCategoryV2?.total || 0);
          const discount = Array.isArray(data?.reportOrderCategoryV2?.data) ? 
              data?.reportOrderCategoryV2?.data.reduce((acc, item) => acc + (parseInt(item?.totalDiscount || 0)), 0) 
              : 0
          setReportCategoryTotalDiscount(
            FormatNumber(
              discount
            )
          );
          setReportCategoryTotalOriginPrice(
            FormatNumber(
              Array.isArray(data?.reportOrderCategoryV2?.data) ? 
              data?.reportOrderCategoryV2?.data.reduce((acc, item) => acc + item?.originSumPrice, 0) 
              : 0
            )
          );
          const _totalPrice = parseInt(Array.isArray(data?.reportOrderCategoryV2?.data) ? 
              data?.reportOrderCategoryV2?.data.reduce((acc, item) => acc + (
                parseInt(item?.totalPrice) ?? 0 + parseInt(item?.totalPriceBaht) ?? 0 + parseInt(item?.totalPriceUsd) ?? 0),
              0 ) 
            : 0)
          setReportCategoryTotalPrice(
            FormatNumber( _totalPrice - discount )
          );
        } else {
          setReportCategory([]);
          console.log("🔴 Get data failed");
        }
      }  
    });

  useEffect(() => {
    _filter();
    getCategory({
      variables: {
        limit: 100,
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
  }, []);

  useEffect(() => {
    _filter();
  }, [cdFillter, category, status]);

  const _filter = async () => {
    try {
      // let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };
      if (category) {
        const categoryData = categories.find((c) => c?.id === category);
        _where = {
          ..._where,
          categoryName: categoryData?.name,
          category: categoryData?.id
        }
      }
      //check if filter date is set
      if (cdFillter) {
        _where = {
          ..._where,
          createdAt_gte: NewCovertTimeZone(cdFillter?.createdAt_gte),
          createdAt_lt: NewCovertTimeZone(cdFillter?.createdAt_lt),
        };
      }
      if (status !== "ALL") {
        _where = {
          ..._where,
          status: status,
        };
      }
      // TODO: Get all order groups
      getreportCategory({
        variables: {
          where: _where,
          // skip: (_skip - 1) * _limit,
          // limit: _limit,
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const safeReport = Array.isArray(reportCategory) ? reportCategory : [];
  let state = {
    series: [
      {
        data: safeReport.map((c) => c?.count ?? 0),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: safeReport.length ? 350 : 10,
      },
      xaxis: {
        categories: safeReport.map((e) => e?._id?.category ?? ""),
      },
    },
  };

  return (
    <>
      <BreadCrumbComponent
        txtSecond={`ລາຍງານປະເພດ`}
      />
      <div style={{ padding: "0 1em" }}>
        <h4><b>ປະເພດການຂາຍ</b></h4>
        <p>ລາຍງານການຂາຍ ຕາມປະເພດສິນຄ້າທີ່ຮ້ານກຳນົດໄວ້</p>

        <Row>
          <Col xs={12} md={2} className="mb-3">
            <Form.Group>
              <Form.Label className="filter-label">ປະເພດ</Form.Label>
              <Form.Select
                className="filter-select"
                onChange={(e) => setCategory(e?.target?.value)}
                value={category}
              >
                <option value="ALL">--ເລືອກ--</option>
                {categories?.length > 0 && categories?.map((category, _index) => (
                  <option key={_index} value={category?.id}>
                    {category?.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md={2} className="mb-3">
            <Form.Group>
              <Form.Label className="filter-label">ສະຖານະ</Form.Label>
              <Form.Select
                className="filter-select action-select"
                onChange={(e) => {
                  const action = e.target.value;
                  setStatus(action);
                }}
                defaultValue={status}
              >
                <option value="ALL">--ເລືອກທັງຫມົດ--</option>
                <option value="COMPLETED">ຊຳລະແລ້ວ</option>
                <option value="INDEBTED">ຕີດຫນີ້</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md={2} className="mb-3"> 
            <Form.Label className="filter-label">ວັນທີ, ເດືອນ, ປີ</Form.Label>
            <Button
              variant="outline-secondary"
              onClick={() => setIsCurrentModals(true)}
              style={{ minWidth: 220 }}
            >
              {!cdFillter ? (
                "mm/dd/yyyy"
              ) : (
                <>
                  {covertTimeZone(cdFillter?.createdAt_gte) +
                    " - " +
                    covertTimeZone(cdFillter?.createdAt_lt)}
                </>
              )}
            </Button>
          </Col>
        </Row>

        <br />
        {loading ? (
          <AnimationLoading />
        ) : (
          <div>
            <Card style={{ padding: 8, marginTop: 10, width: "100%" }}>
              <Card.Body>
                <ReactApexChart
                  options={state.options}
                  series={state.series}
                  type="bar"
                  height={500}
                />
              </Card.Body>
            </Card>

            <div style={{
              width: "100%", height: "auto",
              margin: "2em 0",
            }}>
              <Row>
                <Col xs={12} md="auto" className="mb-3">
                  <p><b>ຕາຕະລາງລາຍງານປະເພດ</b></p>
                </Col>
                <Col xs={12} md="auto" className="mb-3">
                  {/* <Form.Label>Total Category</Form.Label> */}
                  <Form.Label>ປະເພດທັງຫມົດ</Form.Label>
                  <Form.Control type="text" value={reportCategoryTotal} readOnly />
                </Col>
                <Col xs={12} md="auto" className="mb-3">
                  <Form.Label>ຈຳນວນທັງຫມົດ</Form.Label>
                  <Form.Control type="text" value={reportCategoryTotalAmount} readOnly />
                </Col>
                <Col xs={12} md="auto" className="mb-3">
                  <Form.Label>ລວມຕົ້ນທືນທັງຫມົດ</Form.Label>
                  <Form.Control type="text" value={reportCategoryTotalOriginPrice} readOnly />
                </Col>
                <Col xs={12} md="auto" className="mb-3">
                  <Form.Label>ລວມຍອດຂາຍທັງຫມົດ</Form.Label>
                  <Form.Control type="text" value={`${reportCategoryTotalPrice} ກີບ`} readOnly />
                </Col>
                <Col xs={12} md="auto" className="mb-3">
                  <Form.Label>ລວມຍອດສ່ວນຫລຸດ</Form.Label>
                  <Form.Control type="text" value={`${reportCategoryTotalDiscount} ກີບ`} readOnly />
                </Col>
              </Row>
              <Card
                style={{
                  padding: "1em",
                  width: "100%",
                  height: "auto",
                }}>
                <div style={{ width: "100%", height: "auto" }}>
                  <Table striped hover>
                    <thead
                      style={{
                        background: "#1F3A60",
                        color: "white",
                        fontWeight: "400",
                      }}>
                      <tr>
                        <th>ລຳດັບ</th>
                        <th>ປະເພດສິນຄ້າ</th>
                        <th>ສະກຸນເງີນ</th>
                        <th>ຈຳນວນ</th>
                        {/* <th>ລາຄາທືນ</th>
                        <th>ລາຄາຂາຍ</th> */}
                        <th>ລວມຕົ້ນທືນ</th>
                        <th>ລວມຍອດຂາຍ</th>
                        <th>ສ່ວນຫລຸດ</th>
                        <th>ກຳໄລ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportCategory?.map((category, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{category?._id?.category}</td>
                          <td>{category?._id?.currency}</td>
                          <td>{category?.count}</td>
                          {/* <td>{numberFormat(category?.originPrice ?? 0)}</td>
                          <td>{numberFormat(category?.price ?? 0)}</td> */}
                          <td>{numberFormat(category?.originSumPrice ?? 0)}</td>
                          <td>{numberFormat(category?.totalPrice ?? 0 + category?.totalPriceBaht ?? 0 + category?.totalPriceUsd ?? 0)}</td>
                          <td>{numberFormat(category?.totalDiscount ?? 0)}</td>
                          <td>{numberFormat((category?.totalPrice ?? 0 + category?.totalPriceBaht ?? 0 + category?.totalPriceUsd ?? 0) - (category?.originSumPrice + category?.totalDiscount) ?? 0)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card>
            </div>
          </div>
        )}
      </div>

      <CurrentDateComponents
        onCloseModal={() => setIsCurrentModals(false)}
        openModal={isCurrentModals}
        setCdFillter={setCdFillter}
        setActiveButton={setActiveButton}
        activeButton={activeButton}
      />
    </>
  );
}
